import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"

export const getBillsBalance = () => {
    return axiosPrivate.get(`/bills/api/v1/bills-balance/`);
}